module.exports = __webpack_public_path__ + "img/de.6e41aa3c.svg";